import React from "react"
import { usePiano } from "."
import DebugView, { busyVal, DebugViewProps, useDebugLogs } from "../embed/components/DebugView"

const PianoDebugView: React.FC<{ additionalActions?: DebugViewProps["actions"], additionalState?: DebugViewProps["state"]}> = ({ additionalActions, additionalState }) => {
  const { logs, addLog } = useDebugLogs()
  const {forceLogin, loginCooldown, state, userInfo} = usePiano()
  return <DebugView
    name="Piano"
    actions={[
      [
        "forceLogin",
        () => forceLogin((user) => addLog(`loginSuccess ${user.email}`))
      ],
      ...(additionalActions || []),
    ]}
    state={[
      ["state", state],
      ["user", userInfo?.user.email || "-"],
      ["token", `${userInfo?.token || ""}`.substring(0, 20)],
      ["loginCooldown", busyVal(loginCooldown)],
      ...(additionalState ?? []),
    ]}
    logs={logs}
    />
}

export default PianoDebugView
